import { openToast } from '@web/components/Toast/GlobalToastPortal'
import useReactiveSessionStorage from '@web/hooks/useReactiveSessionStorage'
import { IS_BROWSER, IS_DEV } from '@web/libs/constants'
import { ClickLog } from '@web/libs/nlog/click/sendClickLog'

export const CLICK_CODE_DEBUG_MODE_KEY = 'CLICK_CODE_DEBUG_MODE'

export const useClickCodeDebugMode = () => {
  const clickCodeDebugModeStorage = useReactiveSessionStorage<boolean>(CLICK_CODE_DEBUG_MODE_KEY)

  if (!IS_DEV) {
    return []
  }

  return clickCodeDebugModeStorage
}

export const isEnableClickCodeDebugMode = () => {
  if (!IS_DEV) return false

  if (!IS_BROWSER) return false

  return window?.sessionStorage.getItem(CLICK_CODE_DEBUG_MODE_KEY) === 'true'
}

export const openClickLogDebugToast = (clickLog: ClickLog) => {
  if (!isEnableClickCodeDebugMode()) return

  openToast({ title: `클릭코드: ${clickLog.area}`, top: 30 })
  console.debug('클릭로그', clickLog)
}
